import { notification } from 'antd'
import i18n from 'i18next'
import { generateMessageError } from 'modules/core/utils'

const firstText = (value) => {
  if (typeof value === 'string') return value
  if (Array.isArray(value)) return value.map(firstText).find(Boolean) ?? null
  return null
}

const mappingErrorMessage = (error) => {
  const data = error?.response?.data
  if (data && typeof data === 'object') {
    const text = [data.message, data.detail, data.non_field_errors].map(firstText).find(Boolean)
    if (text) return text
  }
  return generateMessageError(error)
}

export const notifyMappingError = (error) =>
  notification.error({
    message: i18n.t('FEEDBACK_DEFAULT_ERROR'),
    description: mappingErrorMessage(error),
    duration: 0,
  })
